import React from "react";
import PropTypes from "prop-types";
import "./Pagination.scss";

/**
 * prepare the links for pagination
 * @param {*} classes
 * @param {*} sections
 * @param {*} page
 * @param {*} grid
 */
const getLinks = (last, current, grid) => {
  let delta = 2,
    left = current - delta,
    right = current + delta + 1,
    range = [],
    rangeWithDots = [],
    l;

  const { rowsPerPage, currentPage } = grid;
  // Iterate through last page and push the button meeting its criteria
  for (let i = 1; i <= last; i++) {
    if (i === 1 || i === last || (i >= left && i < right)) {
      range.push(i);
    }
  }

  /**
   * Function is to push element in Array
   */
  function pushElement(count) {
    rangeWithDots.push(
      <li
        key={count}
        onClick={
          currentPage !== count
            ? () => grid.handlePaginateClick(count, rowsPerPage)
            : undefined
        }
        className="page-item active1"
      >
        <button
          type="button"
          className={`${count === currentPage ? "page-link " : ""}page-no`}
        >
          {count}
        </button>
      </li>
    );
  }

  // Iterate and generate the Links
  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        let count = l + 1;
        pushElement(count);
      } else if (i - l !== 1) {
        rangeWithDots.push("...");
      }
    }
    pushElement(i);
    l = i;
  }

  return rangeWithDots;
};

/**
 * Function to create custom pagination
 */
const Pagination = ({ totalRecords, grid }) => {
  const { rowsPerPage, currentPage } = grid;
  // calculate the number of pages
  let sections = Math.ceil(totalRecords / rowsPerPage);
  return (
    <div className="page-mob">
      <ul className="pagination pull-right float-right">
        <li className="page-item">
          <button
            type="button"
            className={`page-link${currentPage !== 1 ? " p-next" : ""}`}
            onClick={() =>
              grid.handlePaginateClick(currentPage - 1, rowsPerPage)
            }
            disabled={currentPage === 1}
          >
            Prev
          </button>
        </li>
        {getLinks(sections, currentPage, grid)}

        <li className="page-item">
          <button
            type="button"
            className={`page-link ${currentPage < sections ? "p-next" : ""}`}
            onClick={() =>
              grid.handlePaginateClick(currentPage + 1, rowsPerPage)
            }
            disabled={currentPage >= sections}
          >
            Next
          </button>
        </li>
      </ul>
    </div>
  );
};

Pagination.propTypes = {
  grid: PropTypes.object.isRequired
};

export default Pagination;
